import { render, staticRenderFns } from "./delivery.vue?vue&type=template&id=8703e4da&"
import script from "./delivery.vue?vue&type=script&lang=js&"
export * from "./delivery.vue?vue&type=script&lang=js&"
import style0 from "./delivery.vue?vue&type=style&index=0&id=8703e4da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports